<template>
  <div class="home">
    <el-dialog title="Item" :visible.sync="dialogFormVisible">
      <el-form
        ref="formItems"
        :model="formItems"
        :rules="rulesItems"
        label-position="left"
        label-width="20%"
      >
        <el-form-item label="Item" prop="item">
          <el-input
            ref="item"
            v-model="formItems.item"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Produto" prop="product">
          <el-input
            v-model="formItems.product"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Quantidade" prop="quantity">
          <el-input
            type="number"
            v-model="formItems.quantity"
            autocomplete="off"
            min="1"
            :disabled="formRules.integrado ? true : false"
          ></el-input>
        </el-form-item>
        <el-form-item label="Preço Unitário" prop="unitPrice">
          <el-input
            type="number"
            v-model="formItems.unitPrice"
            autocomplete="off"
            @keypress.enter.native="addItem()"
            min="0"
            :disabled="formRules.integrado ? true : false"
          ></el-input>
        </el-form-item>
        <el-form-item label="Total" prop="total">
          <el-input v-model="total" disabled autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="success" @click="addItem()">Salvar item</el-button>
      </span>
    </el-dialog>

    <el-card shadow="always">
      <el-page-header
        @back="goBack"
        v-if="id === ''"
        content="Nova Nota Fiscal"
      ></el-page-header>
      <el-page-header
        @back="goBack"
        v-if="id !== ''"
        content="Atualizar Nota Fiscal"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        label-position="top"
        label-width="100px"
        ref="formRules"
        :model="formRules"
        :rules="rules"
      >
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-row :gutter="5">
              <el-col :xs="24" :sm="11" :md="11" :lg="7" :xl="7">
                <el-form-item label="Número da Nota Fiscal" prop="invoice">
                  <el-input
                    id="removeArrows"
                    type="number"
                    ref="invoice"
                    v-model="formRules.invoice"
                    :min="0"
                    :disabled="formRules.integrado ? true : false"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="11" :md="11" :lg="7" :xl="7">
                <el-form-item label="Contato do Comprador" prop="contact">
                  <el-input
                    ref="contact"
                    placeholder="Contato do Comprador"
                    v-model="formRules.contact"
                    :disabled="formRules.integrado ? true : false"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="6" :md="4" :lg="2" :xl="2">
                <el-form-item label="Serie" prop="serie">
                  <el-input
                    class="maiusculo"
                    type="text"
                    ref="serie"
                    placeholder="Serie"
                    v-model="formRules.serie"
                    :disabled="formRules.integrado ? true : false"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="7" :xl="7">
                <el-form-item label="Data de Emissão" prop="issueAt">
                  <el-date-picker
                    v-model="formRules.issueAt"
                    ref="issueAt"
                    type="date"
                    format="dd/MM/yyyy"
                    placeholder="Selecione"
                    :disabled="formRules.integrado ? true : false"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="24" :sm="6" :md="6" :lg="5" :xl="5">
                <el-form-item label="CNPJ" prop="federalId">
                  <el-select
                    v-if="!isAdmin"
                    v-model="formRules.federalId"
                    filterable
                    placeholder="Selecione"
                    :disabled="id !== ''"
                  >
                    <el-option
                      v-for="item in cnpjs"
                      :key="item.key"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>

                  <el-input
                    v-if="isAdmin"
                    ref="federalId"
                    v-mask="'##.###.###/####-##'"
                    v-model="formRules.federalId"
                    :disabled="id !== ''"
                    @blur="changeFederalId"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="16" :md="16" :lg="11" :xl="11">
                <el-form-item label="Nome" prop="federalName">
                  <el-input
                    ref="federalName"
                    v-model="formRules.federalName"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
                <el-form-item label="Pedido de Compra" prop="request">
                  <el-select
                    multiple
                    v-model="requestArray"
                    filterable
                    placeholder="Selecione"
                    :disabled="id !== '' ? true : false"
                  >
                    <el-option
                      v-for="item in purchases"
                      :key="item.numero"
                      :label="item.numero"
                      :value="item.numero"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
                <el-form-item label="Tipo" prop="type">
                  <el-select
                    v-model="formRules.type"
                    filterable
                    placeholder="Selecione"
                    :disabled="formRules.integrado ? true : false"
                  >
                    <el-option
                      v-for="item in types"
                      :key="item.code"
                      :label="item.description"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
                <el-form-item label="Espécie" prop="kind">
                  <el-select
                    v-model="formRules.kind"
                    filterable
                    placeholder="Selecione"
                    :disabled="formRules.integrado ? true : false"
                  >
                    <el-option
                      v-for="item in species"
                      :key="item.code"
                      :label="item.description"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5" v-if="prefix !== 'tembici'">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <el-button type="info" @click="openAdd()" disabled>
                  <i class="el-icon-plus"></i>&nbsp;Adicionar Itens
                </el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-table
          v-if="prefix !== 'tembici' || partialDelivery"
          :data="items"
          ref="tableItem"
          style="width: 100%"
          :summary-method="getSummaries"
          show-summary
          :default-sort="{ prop: 'requestNumber', order: 'descending' }"
        >
          <el-table-column label="Ped Compra / Projeto" width="100px">
            <template slot-scope="scope">
              {{ scope.row.requestNumber }}
            </template>
          </el-table-column>

          <el-table-column label="Item" width="80px">
            <template slot-scope="scope">
              {{ scope.row.item }}
            </template>
          </el-table-column>

          <el-table-column label="Produto">
            <template slot-scope="scope">
              {{ scope.row.product }}
            </template>
          </el-table-column>

          <el-table-column label="Qtde Pedido">
            <template slot-scope="scope">
              {{ scope.row.quantity }}
            </template>
          </el-table-column>

          <el-table-column label="Qtde Sendo Entregue" width="190px">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.branchDelivery"
                controls-position="right"
                :min="0"
                :max="scope.row.quantity - 0"
                :disabled="!scope.row.partialDelivery"
              ></el-input-number>
            </template>
          </el-table-column>

          <el-table-column label="Preço Unitário">
            <template slot-scope="scope">{{
              scope.row.unitPrice
                | currency("R$", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ","
                })
            }}</template>
          </el-table-column>

          <el-table-column label="Valor Total">
            <template slot-scope="scope">{{
              (scope.row.branchDelivery * scope.row.unitPrice)
                | currency("R$", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ","
                })
            }}</template>
          </el-table-column>

          <el-table-column label="Qtde Entregue">
            <template slot-scope="scope">
              {{ scope.row.delivery }}
            </template>
          </el-table-column>

          <el-table-column width="84px" label="Remover Itens do Pedido">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click.native.prevent="findColumnBeforeDelete(scope.row)"
                :disabled="formRules.integrado || !scope.row.partialDelivery"
              >
                <i class="el-icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <br />

        <el-row>
          <el-col :span="6" :xs="24">
            <el-form-item>
              <el-button
                :type="items.length === 0 ? 'info' : 'primary'"
                @click="add()"
                v-if="id === ''"
                :disabled="items.length === 0"
              >
                Registrar Nota Fiscal
              </el-button>
              <el-button
                :type="formRules.integrado ? 'info' : 'primary'"
                @click="update()"
                v-if="id !== ''"
                :disabled="
                  items.length === 0 || formRules.integrado ? true : false
                "
              >
                <i class="el-icon-check"></i>&nbsp;Atualizar
              </el-button>
            </el-form-item>
          </el-col>

          <el-col :span="6" :xs="6">
            <el-form-item prop="file">
              <el-upload
                class="upload-demo"
                ref="upload"
                drag
                :multiple="true"
                :file-list="fileList"
                action="/api/invoices/upload/"
                :auto-upload="false"
                :on-preview="onPreview"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Anexar Nota fiscal e/ou de acordo da prestação de serviço.
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { UserTypeEnum, UserService } from "../../services/users/user.services";
import { InvoicesService } from "../../services/invoices/invoices.services";
import { mapGetters } from "vuex";

export default {
  name: "InvoiceAdd",
  components: {},
  data() {
    const checkMaiusculo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Informe o contato do comprador"));
      }
      const vm = this;
      const words = value.toLowerCase().split(" ");
      for (let a = 0; a < words.length; a++) {
        if (words[a] !== "") {
          const w = words[a];
          words[a] = w[0].toUpperCase() + w.slice(1);
        } else {
          words.splice(a, 1);
        }
      }
      vm.formRules.contact = words.join(" ");
      callback();
    };
    const checkQuantity = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Informe um valor"));
      }
      setTimeout(() => {
        if (value <= 0) {
          callback(new Error("Quantidade deve ser superior a 0"));
        } else {
          callback();
        }
      }, 1000);
    };

    const checkOut = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Informe um valor"));
      }
      callback();
    };

    const checkSerie = (rule, value, callback) => {
      const vm = this;
      if (!value) {
        return callback(new Error("Informe a série da nota"));
      }
      vm.formRules.serie = value.toUpperCase();
      callback();
    };

    return {
      payload: "",
      partialDelivery: false,
      prefix: "",
      isAdmin: false,
      dialogFormVisible: false,
      id: "",
      index: -1,
      cnpjs: [],
      types: [],
      species: [],
      items: [],
      fileList: [],
      purchases: [],
      deliveries: [],
      requestArray: [],
      sequence: 1,
      total: "",
      user: {
        name: "",
        out: false,
        federalId: "",
        tipo: "2"
      },
      formItems: {
        item: "",
        product: "PRENOTA",
        purchase: 0,
        quantity: 1,
        unitPrice: 0,
        total: 0
      },
      formRules: {
        invoice: "",
        contact: "",
        serie: "",
        issueAt: "",
        type: "",
        kind: "",
        request: "",
        federalId: "",
        federalName: "",
        federalValid: false,
        integrado: false
      },
      rules: {
        invoice: [
          {
            required: true,
            pattern: "^[0-9]{1,9}$",
            message: "Informe uma nota de no máximo 9 digitos",
            trigger: "blur"
          }
        ],
        contact: [{ validator: checkMaiusculo, trigger: "blur" }],
        serie: [
          {
            required: true,
            validator: checkSerie,
            trigger: "blur"
          }
        ],
        type: [
          {
            required: true,
            message: "Informe o tipo",
            trigger: "blur"
          }
        ],
        kind: [
          {
            required: true,
            message: "Informe a espécie",
            trigger: "blur"
          }
        ],
        federalId: [
          {
            required: true,
            message: "Informe um CNPJ",
            trigger: "blur"
          }
        ],
        issueAt: [
          {
            validator: checkOut,
            required: true,
            trigger: "change"
          }
        ]
      },
      rulesItems: {
        item: [
          {
            required: true,
            message: "Informe um item",
            trigger: "blur"
          }
        ],
        product: [
          {
            required: true,
            message: "Informe um produto",
            trigger: "blur"
          }
        ],
        quantity: [{ validator: checkQuantity, trigger: "blur" }],
        unitPrice: [{ validator: checkQuantity, trigger: "blur" }],
        total: [{ validator: checkQuantity, trigger: "blur" }]
      }
    };
  },
  watch: {
    "formItems.quantity": function(val) {
      const val1 = Number(val);
      const val2 = Number(this.formItems.unitPrice);
      this.formItems.total = val1 * val2;
      const valueString = this.formItems.total.toFixed(2).replace(".", ",");
      this.total = `R$ ${valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
    },
    "formItems.unitPrice": function(val) {
      const val1 = Number(val);
      const val2 = Number(this.formItems.quantity);
      this.formItems.total = val1 * val2;
      const valueString = this.formItems.total.toFixed(2).replace(".", ",");
      this.total = `R$ ${valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
    },
    "formRules.federalId": function(newVal) {
      if (!this.isAdmin) {
        this["formRules.federalId"] = newVal;
        this.changeFederalId();
      }
    },
    requestArray: {
      handler: function(newVal, oldVal) {
        const vm = this;
        if (!vm.requestArray || vm.requestArray.length <= 0)
          vm.partialDelivery = false;
        const checkRemovedElements = oldVal.filter(element => {
          if (newVal.indexOf(element) === -1) {
            return element;
          }
        });

        if (checkRemovedElements.length > 0) {
          const loading = vm.$loading({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          const oldArray = [].concat(vm.items);
          let elementIndex;

          oldArray.forEach((element, index) => {
            if (element.requestNumber === checkRemovedElements[0]) {
              if (elementIndex === undefined) {
                elementIndex = index;
              }
              vm.deleteItem(elementIndex, vm.items);
            }
          });
          return loading.close();
        }
        const checkNewElements = newVal.filter(element => {
          if (oldVal.indexOf(element) === -1) {
            return element;
          }
        });

        if (checkNewElements.length > 0) {
          this.changeRequest(checkNewElements[0]);
          return;
        }
      }
    }
  },
  methods: {
    ...mapGetters("auth", ["getCompanyId"]),
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      const vm = this;
      let desconto = 0;
      let acrescimo = 0;
      columns.forEach((column, index) => {
        if (index === 4 || index === 5 || index === 6) {
          let value = 0;
          vm.items.forEach((element, itemIndex) => {
            if (index === 4 && element.branchDelivery > 0) {
              desconto += Number(element.otherValues) || 0;
              value += Number(element.otherValues) || 0;
            }

            if (index === 5 && element.branchDelivery > 0) {
              if (
                itemIndex === 0 ||
                element.requestNumber === vm.items[itemIndex - 1].requestNumber
              ) {
                acrescimo += Number(element.valores) || 0;
                value += Number(element.valores) || 0;
              }
            }

            if (index === 6) {
              value += Number(element.branchDelivery * element.unitPrice);
            }
          });

          let valueString = Number(value)
            .toFixed(2)
            .replace(".", ",");
          valueString = valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

          if (index === 4) {
            sums[index] = `Descontos: R$${valueString}`;
          }

          if (index === 5) {
            sums[index] = `Acrescimos: R$${valueString}`;
          }

          if (index === 6) {
            const totalValue = Number(value + acrescimo - desconto)
              .toFixed(2)
              .replace(".", ",");
            valueString = totalValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            sums[index] = `Total: R$${valueString}`;
          }

          const id = column.id;
          let total;
          if (id) {
            total = document.getElementsByClassName(id);
            if (total.length > 2) {
              total[total.length - 1].style.fontWeight = "bold";
            }
          }
        }
      });

      return sums;
    },

    onPreview: function(file) {
      const a = document.createElement("a"); //Create <a>
      a.href = file.url;
      a.download = file.name;
      a.click();
    },

    findColumnBeforeDelete(column) {
      const vm = this;
      vm.items.every((element, index) => {
        if (element === column) {
          vm.deleteItem(index, vm.items);
          return false;
        }
        return true;
      });
      vm.items.forEach((element, index) => {
        if (element.product === "PRENOTA")
          element.item = `0000${index + 1}`.slice(-4);
      });
      if (vm.items.length > 0) {
        vm.sequence = vm.items.length;
      } else {
        vm.sequence = 1;
      }
    },

    deleteItem(index, rows) {
      rows.splice(index, 1);
      const vm = this;
      const hasPartialDeliveries =
        vm.items.findIndex(value => value.partialDelivery) > -1;
      vm.partialDelivery = hasPartialDeliveries;
    },
    changeFederalId() {
      const vm = this;
      vm.fetchPurchase();
    },
    changeRequest(yourRequest) {
      const vm = this;
      if (yourRequest) {
        vm.sequence = 1;
        const loading = vm.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        const record = vm.purchases.filter(x => x.numero === yourRequest);
        if (record.length > 0) {
          const products = [];

          for (const row of record[0].produtos) {
            if (row.quantity > 0) {
              if (row.entrega_parcial === "S" && !vm.partialDelivery)
                vm.partialDelivery = true;
              const index = products.length;
              products.push(row);
              products[index].branchDelivery = row.quantity - 0;
              products[index]["partialDelivery"] = row.entrega_parcial === "S";
              products[index]["valores"] = record[0].valores;
            }
          }

          if (products.length !== 0) {
            if (vm.items.length === 0) {
              vm.items = [...products];
            } else {
              vm.items.push(...products);
            }
          } else {
            vm.requestArray.splice(vm.requestArray.length - 1, 1);
            this.$message({
              type: "error",
              message: `Pedido ${record[0].numero} já utilizado.`
            });
          }
        } else {
          this.$message({
            type: "error",
            message: "Pedido não encontrado para esse fornecedor!"
          });
        }
        loading.close();
      }
    },

    addItem: function() {
      const vm = this;
      this.$refs.formItems.validate(valid => {
        if (valid) {
          vm.dialogFormVisible = false;
          const o = {
            requestNumber: vm.formRules.request,
            item: `0000${vm.sequence}`.slice(-4),
            product: vm.formItems.product,
            purchase: vm.formItems.purchase,
            quantity: vm.formItems.quantity,
            unitPrice: vm.formItems.unitPrice,
            otherValues: 0,
            valores: 0,
            total: vm.formItems.total,
            delivery: 0,
            custom: true,
            branchDelivery: vm.formItems.quantity
          };
          if (vm.index === -1) {
            vm.items.push(o);
            vm.$message({
              type: "success",
              message: "Item adicionado com sucesso!"
            });
            vm.$refs.item.$el.children[0].focus();
            vm.sequence++;
          } else {
            const item = vm.items;
            item[vm.index] = o;
            vm.items = [];
            setTimeout(() => {
              vm.items = item;
              vm.dialogFormVisible = false;
              vm.index = -1;
            }, 500);
          }
          vm.$refs.formItems.resetFields();
        }
      });
    },
    openAdd: function() {
      const vm = this;
      vm.dialogFormVisible = true;
      if (vm.$refs.formItems) {
        vm.$refs.formItems.resetFields();
      }
      vm.formItems.item = `0000${vm.sequence}`.slice(-4);
    },
    fetchPurchase() {
      const vm = this;

      if (vm.formRules.federalId) {
        const loading = vm.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        vm.formRules.federalName = "";
        vm.formRules.federalValid = false;
        InvoicesService.purchase(vm.formRules.federalId, vm.getCompanyId())
          .then(response => {
            const purchasesData = response.purchases;
            if (purchasesData.errorMessage) {
              return vm.$message({
                type: "error",
                message: purchasesData.errorMessage
              });
            }

            vm.payload = response.payload;
            vm.formRules.federalName = purchasesData.nome_fornecedor;
            vm.formRules.federalValid = true;
            if (purchasesData.pedidos && purchasesData.pedidos.length > 0) {
              vm.purchases = purchasesData.pedidos;
            }
          })
          .catch(error => {
            this.$message({
              type: "error",
              message: error
            });
          })
          .finally(() => loading.close());
      }
    },

    goBack: function() {
      const vm = this;
      vm.$router.push({ name: "home" });
    },
    add: function() {
      const vm = this;

      this.$refs.formRules.validate(valid => {
        if (valid) {
          if (vm.items.length === 0) {
            return this.$message({
              type: "error",
              message: "É obrigatório informar ao menos um item!"
            });
          }

          if (!vm.formRules.federalValid) {
            return this.$message({
              type: "error",
              message: "Favor informar um fornecedor válido!"
            });
          }

          let has = false;
          const itemsAceito = [];
          for (const row of vm.items) {
            if (row.branchDelivery > 0) {
              has = true;
              itemsAceito.push(row);
            }
          }

          if (!has) {
            return this.$message({
              type: "error",
              message:
                "É preciso informar ao menos uma quantidade sendo entregue para um dos itens!"
            });
          }

          if (vm.$refs.upload.uploadFiles.length === 0) {
            return this.$message({
              type: "error",
              message: "É obrigatório anexar ao menos um arquivo!"
            });
          }

          let requestNumber = "";
          vm.requestArray.forEach(element => {
            requestNumber += `${element};`;
          });

          if (!requestNumber && !vm.formRules.request) {
            return this.$message({
              type: "error",
              message:
                "Você não informou o pedido/projeto, favor entrar em contato através do fale conosco, informando o nome e telefone da pessoa que contratou seu produto para que seja providenciado o número do pedido/projeto!"
            });
          }

          const loading = vm.$loading({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });

          InvoicesService.add(
            Number(vm.formRules.invoice),
            vm.formRules.contact,
            vm.formRules.serie,
            vm.formRules.issueAt,
            vm.formRules.type,
            vm.formRules.kind,
            requestNumber ? requestNumber : null,
            vm.$refs.upload.uploadFiles.length === 0
              ? null
              : vm.$refs.upload.uploadFiles,
            itemsAceito,
            vm.formRules.federalId,
            vm.formRules.federalName,
            vm.getCompanyId(),
            vm.payload
          )
            .then(() => {
              this.$message({
                type: "success",
                message: "Nota incluida com sucesso!"
              });
              vm.fileList = [];
              this.$refs.formRules.resetFields();
              vm.items = [];
              vm.goBack();
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error
              });
            })
            .finally(() => loading.close());
        } else {
          return this.$message({
            type: "error",
            message: "Os campos com * são obrigatórios!"
          });
        }
      });
    },
    update: function() {
      const vm = this;

      this.$refs.formRules.validate(valid => {
        if (valid) {
          let has = false;
          const itemsAceito = [];
          for (const row of vm.items) {
            if (
              row.branchDelivery > 0 ||
              (row.branchDelivery > 0 && row.delivery === 0)
            ) {
              has = true;
              itemsAceito.push(row);
            } else if (row.branchDelivery === 0 && row.delivery > 0) {
              has = true;
              row.branchDelivery = parseInt(row.quantity - row.delivery);
              row.delivery = 0;
              itemsAceito.push(row);
            }
          }

          if (!has) {
            return this.$message({
              type: "error",
              message:
                "É preciso informar ao menos uma quantidade sendo entregue para um dos itens!"
            });
          }

          const loading = vm.$loading({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });

          InvoicesService.update({
            id: vm.id,
            invoice: Number(vm.formRules.invoice),
            contact: vm.formRules.contact,
            serie: vm.formRules.serie,
            issueAt: vm.formRules.issueAt,
            type: vm.formRules.type,
            kind: vm.formRules.kind,
            files:
              vm.$refs.upload.uploadFiles.length === 0
                ? null
                : vm.$refs.upload.uploadFiles,
            items: itemsAceito,
            payload: vm.payload
          })
            .then(() => {
              this.$message({
                type: "success",
                message: "Nota atualizada com sucesso!"
              });
              vm.items = itemsAceito;
              vm.goBack();
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error
              });
            })
            .finally(() => loading.close());
        } else {
          return this.$message({
            type: "error",
            message: "Os campos com * são obrigatórios!"
          });
        }
      });
    },
    get: function() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      InvoicesService.get(vm.id)
        .then(response => {
          const requestNumber = response.request;
          if (requestNumber && requestNumber.indexOf(";") >= 0) {
            let string = requestNumber.substr(0, requestNumber.indexOf(";"));
            const inicio = string.length + 1;
            vm.requestArray.push(string);

            for (
              let i = inicio, count = 1, fim = requestNumber.indexOf(";");
              i < requestNumber.length;
              i += inicio, count++
            ) {
              string = requestNumber.substr(i, fim);
              vm.requestArray.push(string);
            }
          } else {
            vm.requestArray.push(requestNumber);
          }

          const payload = response.payload.pop();
          vm.payload = payload
            ? Buffer.from(JSON.stringify(payload)).toString("base64")
            : "";
          vm.formRules.invoice = response.invoice;
          vm.formRules.contact = response.contact;
          vm.formRules.serie = response.serie;
          vm.formRules.issueAt = new Date(`${response.issueAt} 08:00:00`);
          vm.formRules.type = response.type;
          vm.formRules.kind = response.kind;
          vm.formRules.federalId = response.federalId;
          vm.formRules.federalName = response.federalName;
          vm.items = response.items;
          vm.id = response.id;
          vm.fileList = response.file;
          vm.formRules.integrado = response.integrado;
          if (response.error) vm.formRules.integrado = false;

          vm.sequence =
            vm.items.length > 0
              ? parseInt(vm.items[vm.items.length - 1].item) + 1
              : 1;
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error
          });

          if (vm.items.length === 0) {
            vm.goBack();
          }
        })
        .finally(() => loading.close());
    },
    fetchTypes: function() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      InvoicesService.types()
        .then(response => {
          vm.types = response;
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error
          });
        })
        .finally(() => loading.close());
    },
    fetchSpecies: function() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      InvoicesService.species()
        .then(response => {
          vm.species = response;
        })
        .catch(error => {
          this.$message({
            type: "error",
            message: error
          });
        })
        .finally(() => loading.close());
    },
    transformCnpj: function(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/, "$1.$2");
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
      v = v.replace(/(\d{4})(\d)/, "$1-$2");
      return v;
    }
  },
  mounted() {
    const vm = this;
    vm.prefix = vm.$route.params.prefix;
    const removeArrows = document.getElementById("removeArrows");
    const dragger = document.getElementsByClassName("el-upload-dragger")[0]
      .style;

    removeArrows.style.MozAppearance = "textfield";
    removeArrows.style["text-align"] = "left";
    dragger.border = "1px dashed #ff0000";

    UserService.me()
      .then(response => {
        vm.isAdmin =
          response.user.type === UserTypeEnum.ADMIN ||
          response.user.type === UserTypeEnum.MASTER;
        if (!vm.isAdmin) {
          const federalId = response.user.federalId;
          let string = federalId.substr(0, federalId.indexOf(";"));
          const inicio = string.length + 1;

          vm.cnpjs.push({
            key: 0,
            label: vm.transformCnpj(string),
            value: string
          });

          for (
            let i = inicio, count = 1, fim = federalId.indexOf(";");
            i < federalId.length;
            i += inicio, count++
          ) {
            string = federalId.substr(i, fim);
            if (string !== ";")
              vm.cnpjs.push({
                key: count,
                label: vm.transformCnpj(string),
                value: string
              });
          }
        }
        vm.user = response.user;
        vm.fetchTypes();
        vm.fetchSpecies();
        vm.fetchPurchase();
      })
      .catch(error => {
        this.$message({
          type: "error",
          message: error
        });
        vm.goBack();
      });

    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    } else {
      vm.$refs.invoice.$el.children[0].focus();
    }
  }
};
</script>
<style scoped>
.el-upload-dragger {
  width: 300px;
  border: 1px dashed #ff0000;
}
.maiusculo input {
  text-transform: uppercase !important;
}
</style>
